<template>
    <el-aside class="borrow-aside" :style='siderHide?"width:50px":"width:210px"'>
        <el-col :span="24" class="sidebar">
            <el-menu
                    :default-active="activeItem"
                    class="el-menu-vertical-demo"
                    :background-color='siderbg'
                    :text-color='textcolor'
                    :active-text-color='activetextcolor'
                    @open="handleOpen"
                    @close="handleClose"
                    @select="handleSelect"
                    :unique-opened="true"
                    :collapse="siderHide"
                    v-for="(item,index) in menu" :key="index"
                    >
                    <el-submenu v-if="item.children.length!=0" :key="index" :index="item.menuUrl" :btn='item.btn' class="sidebar-submenu">
                            <template slot="title">
                                <i class="icon iconfont sidebar-icon" :class="item.icon"></i>
                                <span class="sidebar-title" :id='item.menuUrl' :btn='item.btn'>{{item.menuName}}</span>
                            </template>
                            <div v-for="(cItem,indexId) in item.children" :key="indexId">
                                <el-submenu :index="cItem.menuUrl" :btn='cItem.btn' v-if='cItem.children.length!=0'>
                                    <template slot="title">
                                        <span class="sidebar-title" style="padding-left:30px;" :id='cItem.menuUrl' :btn='cItem.btn'>{{cItem.menuName}}</span>
                                    </template>
                                        <el-menu-item v-for="(dItem,indexId2) in cItem.children" :key="indexId2" :index="dItem.menuUrl" :btn='dItem.btn' style="padding-left:40px;" :id='dItem.menuUrl'>{{dItem.menuName}}</el-menu-item>
                                </el-submenu>
                                <el-menu-item-group v-else style="text-indent:30px;">
                                        <el-menu-item :index="cItem.menuUrl" :key="indexId" :btn='cItem.btn' :id='cItem.menuUrl' style='padding-left:10px;'>{{cItem.menuName}}</el-menu-item>
                                </el-menu-item-group>
                            </div>
                    </el-submenu>
                    <div v-else>
                        <el-menu-item :key="index" :index="item.menuUrl" class="sidebar-submenu" style="text-align:left;padding-left: 5px;" :btn='item.btn'>
                            <i class="icon iconfont sidebar-icon" :class="item.icon"></i>
                            <span slot="title" class="sidebar-title" :id='item.menuUrl' :btn='item.btn'>{{item.menuName}}</span>
                        </el-menu-item>
                    </div>
            </el-menu>
        </el-col>
    </el-aside>
</template>


<script>
    import { mapState } from "vuex";
    import styles from '../assets/css/all.scss';
    import store from '../store/store'
    import { setTimeout } from 'timers';
    export default {
        name: 'sidebar',
        data() {
            return {
                 /* menu:[
                      
                    {
                        icon: "icon-liucheng",
                        id: 1,
                        name:'indexin',
                        menuName:'通讯录',
                        btn:'',
                        children:[
                            {
                                icon: "icon-liucheng",
                                id: 1,
                                name:'addTel',
                                menuName:'通讯录成员',
                                btn:'',
                                children:[]
                            }
                        ]
                    },
                    {
                        icon: "icon-liucheng",
                        id: 1,
                        name:'auth',
                        menuName:'我的企业',
                        btn:'',
                        children:[
                            {
                                icon: "icon-liucheng",
                                id: 1,
                                name:'stationManage',
                                menuName:'部门管理',
                                btn:'',
                                children:[]
                            },
                            // {
                            //     icon: "icon-liucheng",
                            //     id: 1,
                            //     name:'permission',
                            //     menuName:'权限管理',
                            //     btn:'',
                            //     children:[]
                            // },
                            {
                                icon: "icon-liucheng",
                                id: 1,
                                name:'telManage',
                                menuName:'通讯录管理',
                                btn:'',
                                children:[]
                            }
                        ]
                    },
                    {
                        icon: "icon-liucheng",
                        id: 1,
                        name:'setting',
                        menuName:'系统配置',
                        btn:'',
                        children:[
                            {
                            icon: "icon-liucheng",
                            id: 1,
                            name:'menuSetting',
                            menuName:'移动端菜单管理',
                            btn:'',
                            children:[
                        ]
                        },
                            {
                            icon: "icon-liucheng",
                            id: 1,
                            name:'menuSettingPC',
                            menuName:'pc端菜单管理',
                            btn:'',
                            children:[
                        ]
                        },
                            {
                                icon: "icon-liucheng",
                                id: 1,
                                name:'clockin',
                                menuName:'打卡地点',
                                btn:'',
                                children:[

                                ]
                            },
                            {
                                icon: "icon-liucheng",
                                id: 1,
                                name:'notice',
                                menuName:'发布公告',
                                btn:'',
                                children:[]
                            }
                        ]
                    },
                    {
                        icon: "icon-liucheng",
                        id: 1,
                        name:'clockHistory',
                        menuName:'打卡记录',
                        btn:'',
                        children:[]
                    }
                ],  */
                menu:[],
                //样式
                siderbg:styles.siderbg,
                textcolor:styles.textcolor,
                activetextcolor:styles.sideractivetextcolor,
                // activeItem: 'manage',
                activeItem:this.$store.state.routertag,
                siderHide:this.$store.state.siderHide,
            }
        },
        created: function () {

            // this.$http.get(this.$apis.sider)
            //     .then((res) => {
            //         if (res.data.code == 0) {
            //             this.menu = res.data.data;
            //         } else {
            //             this.$alert('请稍后再试~')
            //         }
            //     })
            var MenuList=JSON.parse(localStorage.getItem('mmm'));
            this.menu= MenuList.List;
            this.activeItem = sessionStorage.getItem('routePath') || this.activeItem;
            // console.log(styles)
            
            var name=this.activeItem;
            // var menu=this.menu;
            // this.menuSendBtn(menu,name);
            // this.getUserIP((ip) => {
            //     console.log(ip)
            // });
        },
        mounted:function(){
            // console.log(this.$store.state.menu)
            this.getMenuList();
            var item=`#${this.activeItem}`;
            if(document.querySelector(item)){
                store.commit('setBtn', (document.querySelector(item).getAttribute('btn')||'').split(','));
            }
        },
        methods: {
            getUserIP(onNewIP) {
                let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
                let pc = new MyPeerConnection({
                    iceServers: []
                });
                let noop = () => {
                };
                let localIPs = {};
                let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
                let iterateIP = (ip) => {
                if (!localIPs[ip]) onNewIP(ip);
                localIPs[ip] = true;
                };
                pc.createDataChannel('');
                pc.createOffer().then((sdp) => {
                sdp.sdp.split('\n').forEach(function (line) {
                    if (line.indexOf('candidate') < 0) return;
                    line.match(ipRegex).forEach(iterateIP);
                });
                pc.setLocalDescription(sdp, noop, noop);
                }).catch((reason) => {
                });
                pc.onicecandidate = (ice) => {
                if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
                ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
                };
            },
            getMenuList() {     
            var that=this;
            var formData={};
            that.postFn(that.$apis.menuView,formData,(res)=>{
            // console.log(res);
            this.menu= JSON.parse(res.body.data);           
            })
            },
            handleOpen(key, keyPath) {
                // console.log('key', keyPath);
            },
            handleClose(key, keyPath) {
                // console.log(key, keyPath); 
            },
            handleSelect(key, keyPath,index) {
                // console.log(index);
                // console.log(keyPath);
                // console.log(this.activeItem) 
                store.commit('setBtn', index.$attrs.btn);
                this.activeItem = key;
                sessionStorage.setItem('routePath', this.activeItem);   
                var routepath='/'+keyPath.join('/');             
                this.$router.push({name:key}); 
                // console.log(location.href);
                console.log(key);
                
                
            }
        },
        
        // computed: {
        //     router1() {
        //         console.log(this.$store.state.routertag)
        //         return this.$store.state.routertag;
        //     }
        // },
        computed:mapState({
            //增加一个变量router1
            router1(state){
                // console.log(state.routertag)
                return state.routertag
            },
            siderHide1(state){
                return state.siderHide
            },
            menu1(state){
                return state.menu
            }
        }),
        watch: {
            //监听
            router1(newData, oldData) {
                // console.log(newData)
                this.activeItem=newData;
                var name=this.activeItem;
                var menu=this.menu;
                // this.menuSendBtn(menu,name)
                var item=`#${this.activeItem}`;
                // console.log(this.$store.state.btn)
                // console.log(document.querySelector(item).getAttribute('btn'))
                if(document.querySelector(item)){
                    store.commit('setBtn', (document.querySelector(item).getAttribute('btn')||'').split(','));
                }
            },
            siderHide1(newData,oldData){
                this.siderHide=newData
            },
            menu1(newData,oldData){
                console.log(newData)
                this.menu=newData
            }
        }
    }
</script>
<style lang='scss'>
    .sidebar .el-menu-item {
            text-align: left !important;
            color:$sider-font-color;
            // padding-left: 60px !important;
        }
    // .sidebar-title{color:$sider-font-color;}
    .sidebar-icon { 
        font-size: 14px;
        color: $sider-font-color!important;
        margin-right: 6px;
        font-weight:normal!important;
    }

    .sidebar-border-active {
        border-left: 4px solid #ffd02b;
    }

    .sidebar-submenu {
        text-align: left;
    }

    .el-menu {
        border: none !important;
        background: $sider-bg!important;
    }

    .sidebar .el-menu-item-group__title {
        padding: 0;
    }

    // .active {
    //     padding-left: 40px;
    //     color: rgb(255, 208, 43);
    //     background-color: rgb(6, 56, 102);
    // }
    .is-active,.router-link-active li{
        // color: rgb(255, 208, 43);
    }
    .is-active i, .is-active>.el-submenu__title{color:$sider-active-text-color!important;}
    a {text-decoration: none;}
    .borrow-aside {height: 100%;background: $sider-bg;border-right:1px solid #efecec;}
    .el-menu--collapse{width:40px;}
    .el-menu-item:focus, .el-menu-item:hover,.el-submenu__title:hover{color:$sider-active-text-color!important;}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue